var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "span",
      {
        staticClass: "product-aside-price product-aside-price--fallback-price",
      },
      [
        _vm._v(
          "\n    Price for " + _vm._s(_vm.fallbackPrice.country_name) + "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "product-aside-prices" }, [
      _vm.hasDiscount
        ? _c(
            "span",
            {
              staticClass:
                "product-aside-price product-aside-price--discounted",
            },
            [
              _c("span", { staticClass: "product-aside-price-was" }, [
                _vm._v(
                  "Was " +
                    _vm._s(
                      _vm.fallbackPrice.compare_at_price_formatted_plus_vat
                    )
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "product-aside-price-now" }, [
                _vm._v(
                  "Now " + _vm._s(_vm.fallbackPrice.price_formatted_plus_vat)
                ),
              ]),
            ]
          )
        : _c("span", { class: _vm.priceClass }, [
            _vm._v(_vm._s(_vm.fallbackPrice.price_formatted_plus_vat)),
          ]),
      _vm._v(" "),
      _vm.hasDiscount
        ? _c(
            "span",
            {
              staticClass:
                "product-aside-price-exvat product-aside-price-exvat--discounted",
            },
            [
              _c("span", { staticClass: "product-aside-price-exvat-was" }, [
                _vm._v(
                  "Was " +
                    _vm._s(_vm.fallbackPrice.compare_at_price_formatted) +
                    " (Ex.VAT)"
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "product-aside-price-exvat-now" }, [
                _vm._v(
                  "Now " +
                    _vm._s(_vm.fallbackPrice.price_formatted) +
                    " (Ex.VAT)"
                ),
              ]),
            ]
          )
        : _c("span", { class: _vm.priceExVatClass }, [
            _vm._v(_vm._s(_vm.fallbackPrice.price_formatted) + " (Ex.VAT)"),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }